import { isMobile } from '@/lib/device'
export default [
  {
    path: 'data/statistic',
    name: 'DataStatistic',
    component: () =>
      isMobile
        ? import(/* webpackChunkName: "mb-base" */ `@/mobile/statistic/Index`)
        : import(/* webpackChunkName: "pc-base" */ `@/pc/statistic/Index`)
  },
  {
    path: 'data/statistic/develop',
    name: 'DataStatisticDevelop',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/statistic/DevelopOverView`)
  },
  {
    path: 'data/statistic/reception',
    name: 'DataStatisticReception',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/statistic/ReceptionOverView`)
  },
  {
    path: 'data/statistic/follow',
    name: 'DataStatisticFollow',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/statistic/FollowOverView`)
  },
  {
    path: 'data/statistic/level',
    name: 'DataStatisticLevel',
    component: () => import(/* webpackChunkName: "mb-base" */ `@/mobile/statistic/components/LevelSelectComponents`)
  },
  {
    path: 'data/statistic/clue',
    name: 'DataStatisticClue',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/pc/statistic/ClueOverView`)
  }
]
